module.exports = __webpack_public_path__ + "static/media/ла.de0d07b9.mp3";